import isArray from 'lodash/isArray';
import downloadBlob from './downloadBlob';

interface DownloadFileProps {
  data: Array<string> | string;
  filename: string;
  type?: string;
}

const downloadFile = ({ data, filename, type }: DownloadFileProps) =>
  downloadBlob({ blob: new Blob(isArray(data) ? data : [data], { type }), filename });

export default downloadFile;
